import Image from "next/image"
import MapIcon from "public/icons/Australia.svg"
import NdisImg from "public/images/NDIS/NDIS-Registered-Provider-white-text.png"
import GoogleReviewImg from "public/images/Google-5-star.png"
import { getGradientClass, getBorderClass } from "~/styles/styles"

type SlimBandType = {
  customBorder?: string
}
const SlimBand = ({ customBorder }: SlimBandType) => {
  const LINE_1 = "With team members located throughout Australia,"
  const LINE_2 = "we provide services Australia-Wide!"
  return (
    <div
      className={`${customBorder ?? getBorderClass} p-8 py-4 font-secondary xs:py-6 ${getGradientClass("h-l-to-d")}`}
    >
      <div className="flex max-w-7xl flex-wrap items-center justify-start gap-3 md:flex-nowrap md:justify-evenly lg:mx-auto">
        <div className="flex items-center gap-3">
          <Image src={MapIcon as string} alt="map" height={50} className="xl:w-16" />
          <p className="flex-col text-sm text-white ml:flex xl:text-base">
            <span>{LINE_1} </span>
            <span>{LINE_2}</span>
          </p>
        </div>
        <Image src={NdisImg} alt="NDIS-logo" height={40} className="xl:w-48" />
        <Image src={GoogleReviewImg} alt="Google-5-star" height={50} className="xl:w-40" />
      </div>
    </div>
  )
}

export default SlimBand
